import { render, staticRenderFns } from "./SurveyTestCompletion.vue?vue&type=template&id=a1fd794e&"
import script from "./SurveyTestCompletion.vue?vue&type=script&lang=js&"
export * from "./SurveyTestCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports